import { FC } from "react"

type IProps = {
    source: string,
    className?: string,
    alt: string,
    width?: number | string,
    height?: number | string
}

const ImageComponent: FC<IProps> = ({ source, alt, className, width = 'auto', height = 'auto', ...otherProps }) => {

    return (
        <img width={width} height={height} src={source} className={`${className}`} alt={alt} {...otherProps} />
    )
}

export default ImageComponent